import { lazy } from 'react';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import { ApplicationPaths, LoginActions, LogoutActions } from 'authorization/ApiAuthorizationConstants';
import Logout from 'authorization/Logout';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const LoginCallback = Loadable(lazy(() => import('authorization/Login')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <GuestGuard>
                    <CommonLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: '/',
                    element: <AuthLogin />,
                },
                {
                    path: 'login',
                    element: <AuthLogin />,
                },
                {
                    path: 'authentication/login-callback',
                    element: <LoginCallback action={LoginActions.LoginCallback} />,
                },
            ],
        },
        {
            path: ApplicationPaths.Login,
            element: <AuthLogin />,
        },
        {
            path: ApplicationPaths.LoginCallback,
            element: <LoginCallback action={LoginActions.LoginCallback} />,
        },
        {
            path: ApplicationPaths.LogOut,
            element: <Logout action={LogoutActions.Logout} />,
        },
        {
            path: ApplicationPaths.LogOutCallback,
            element: <Logout action={LogoutActions.LogoutCallback} />,
        },
    ],
};

export default LoginRoutes;
